import React from 'react';
import { Alert, Button } from 'reactstrap';
import i18next from 'i18next';

import { ModalTypes } from 'config';
import Order from 'utils/orders';
import { getSafeLsJSON } from 'utils/parsers';
import type { NormalizedRestaurant, OrdersConfig } from 'types';
import type { TSetModalFunction } from 'app/containers/WithSetModal';

type OrdersDeliveryTimeAlertProps = {
  ordersConfig: OrdersConfig
  restaurant: NormalizedRestaurant;
  setModal: TSetModalFunction;
  updateOrdersConfig: (payload: Partial<OrdersConfig>, restaurant: NormalizedRestaurant) => void;
}

type OrdersDeliveryTimeAlertState = {
  alertActionDate: Date;
  visible: boolean;
  useLastRemindAlert?: Date;
}

class OrdersDeliveryTimeAlert extends React.Component<OrdersDeliveryTimeAlertProps, OrdersDeliveryTimeAlertState> {
  state: OrdersDeliveryTimeAlertState = {
    alertActionDate: new Date(),
    visible: true,
  };

  onDismiss = () => {
    this.setState({
      visible: !this.state.visible,
    });
  };
  setTimeForAlertToLocalStorage = () => {
    const d = new Date();
    this.setState({
      useLastRemindAlert: d,
    });
    localStorage.setItem(
      'hidePrepareOrderAlertUntil',
      this.state.alertActionDate.toISOString()
    );
  };

  changeDeliveryTime = () => {
    this.props.setModal(
      {
        title: i18next.t('orders-delivery-time-alert.modal-title'),
        text: '',
        options: Order.DELIVERY_PREPARE_TIMES.map((time) => time.toString()),
        confirm: (selected) => {
          const payload: Partial<OrdersConfig> = {
              deliveryTime: parseInt(selected, 10),
          };
          this.props.updateOrdersConfig(payload, this.props.restaurant);
        },
        confirmColor: 'success',
        confirmText: i18next.t('Confirm'),
        cancelText: i18next.t('Cancel'),
      },
      ModalTypes.SELECT
    );
  };

  hasWeekPassedSinceDismiss = () => {
    const oneWeekTime = 1000 * 60 * 60 * 24 * 7;
    const getTimeDoNotDisplayAlert = localStorage.getItem(
      'hidePrepareOrderAlertUntil'
    );
    if (!getTimeDoNotDisplayAlert) {
      return true;
    }
    if (
      ((new Date()).getTime() - Date.parse(getTimeDoNotDisplayAlert)) >=
      oneWeekTime
    ) {
      return true;
    }
    return false;
  };

  render() {
    const { deliveryTime } = this.props.ordersConfig;
    const lastOrderPrepareTimes = getSafeLsJSON(
      `${this.props.restaurant.id}-delivery-times`,
      []
    );
    if (!lastOrderPrepareTimes || lastOrderPrepareTimes.length < 5) {
      return null;
    }
    const sumValues = (accumulator, curr) => accumulator + curr;
    const last5OrderAvgTime =
      lastOrderPrepareTimes.reduce(sumValues) / lastOrderPrepareTimes.length;
    const shouldDisplayAlert =
    deliveryTime && 
      Math.abs(last5OrderAvgTime - deliveryTime) >= 30 &&
      this.hasWeekPassedSinceDismiss();

    return (
      shouldDisplayAlert && (
        <Alert
          color="info"
          isOpen={this.state.visible}
          toggle={this.onDismiss}
          fade={false}
        >
          <h4>
            {i18next.t('orders-delivery-time-alert.discrepancy-warning')}
          </h4>
          <hr />
          <h5>{i18next.t('orders-delivery-time-alert.declared-time', { time: deliveryTime })}</h5>
          <h5>{i18next.t('orders-delivery-time-alert.avg-time', { time: last5OrderAvgTime })}</h5>
          <Button
            className="mb-2"
            color="success"
            onClick={this.changeDeliveryTime}
          >
            {i18next.t('orders-delivery-time-alert.change-delivery-time')}
          </Button>{' '}
          <Button
            className="mb-2"
            color="secondary"
            onClick={this.setTimeForAlertToLocalStorage}
          >
            {i18next.t('orders-delivery-time-alert.dismiss-for-a-week')}
          </Button>
        </Alert>
      )
    );
  }
}

export default OrdersDeliveryTimeAlert;
